import gsap from 'gsap';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
gsap.registerPlugin(ScrollToPlugin);

export const getScrollDirection = (lastScrollPos, currScrollPos) => {
	return lastScrollPos < currScrollPos ? 'down' : 'up';
};

export const scrollToYPos = (yPos = 0, duration = 0.75) => {
	gsap.to(window, {
		duration,
		ease: 'Power2.easeInOut',
		scrollTo: { y: yPos, x: 0 },
	});
};

export const scrollToTop = () => {
	const elems = document.querySelectorAll('.js-scroll-top');

	elems.forEach((el) => {
		el.addEventListener('click', (e) => {
			e.preventDefault();

			scrollToYPos(0, 1.8);
		});
	});
};

export const scrollToNextSection = (trigger) => {
	const nextSection = trigger.closest('section.module').nextElementSibling;
	if (!nextSection) {
		console.warn('no next section for scroll target found.');
	}

	if (nextSection.getBoundingClientRect()) {
		const topOffset = window.scrollY + nextSection.getBoundingClientRect().top;
		scrollToYPos(topOffset, 1.8);
	}
};
